import { CREATEPHARMACYMEDICINE, DELETEPHARMACYMEDICINE, GETALLPHARMACYMEDICINEQTY, GETPHARMACYMEDICINE, UPDATEPHARMACYMEDICINE } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    
    switch (action.type) {
        case CREATEPHARMACYMEDICINE:
            return {
                ...state,
                pharmacymedicineSaveStatus: action.payload.success,
            }
        case GETPHARMACYMEDICINE:
                return {
                        ...state,
                        pharmacymedicineList: action.payload.data,
                        }
        case GETALLPHARMACYMEDICINEQTY:
                return {
                        ...state,
                        pharmacymedicineqtyList: action.payload.data,
                        }
        case UPDATEPHARMACYMEDICINE:
                return {
                        ...state,
                        pharmacymedicineUpdateStatus: action.payload.success,
                        }   

        case DELETEPHARMACYMEDICINE:
                 return {
                     ...state,
                     pharmacymedicineDeleteStatus: action.payload.success,
                        } 

                        default:
                            return state
                             }
                         }